export function stringToHexColor(text: string): {
  background: string;
  color: string;
} {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  let background = '#';
  let r = 0,
    g = 0,
    b = 0;
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    background += ('00' + value.toString(16)).slice(-2);
    if (i === 0) r = value;
    if (i === 1) g = value;
    if (i === 2) b = value;
  }

  // Calcular luminância relativa (método aproximado)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Escolher cor de contraste (preto ou branco) com base na luminância
  const color = luminance > 0.5 ? '#000000' : '#FFFFFF';

  return { background, color };
}
